import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getgreenLeafReportData,
    getDivisionByEstateID,
    getAllEmployeeTypesForDropdown,
    getGangByCollectionPointID
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getAllEmployeeTypesForDropdown() {
    var employeeTypesArray = [];
    const response = await CommonGet('/api/Employee/GetAllEmployeeTypes', null)
    for (let item of Object.entries(response.data)) {
        employeeTypesArray[item[1]["employeeTypeID"]] = item[1]["employeeTypeName"]
    }
    return employeeTypesArray;

}


async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}


async function getGangByCollectionPointID(estateID, divisionID) {
    var gangArray = [];
    const response = await CommonGet('/api/Gang/GetGangBySearch', "operationEntityID=" + parseInt(estateID) + '&collectionPointID=' + parseInt(divisionID));
    for (let item of Object.entries(response.data)) {
        gangArray[item[1]["gangID"]] = item[1]["gangName"]
    }
    return gangArray;
}

async function getgreenLeafReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        year: parseInt(moment(data.month).format('YYYY')),
        month: parseInt(moment(data.month).format('MM')),
        gangID: parseInt(data.gangID)
    };
    const response = await CommonPost('/api/GreenLeafReport/GetGreanLeafReport', null, model);
    return response.data;
}
